<template>
  <div class="version-page-layout position-relative">
    <my-svg type="feature" />
    <div class="w-full flex-1 flex flex-col items-center justify-center">
      <div class="w-full lg:w-1/2 h-[500px] xl:h-[600px] 2xl:h-[800px] rounded-lg overflow-hidden">
        <iframe src="https://player.bilibili.com/player.html?bvid=BV1WgYYzhEKw&autoplay=0" scrolling="no" border="0"
          frameborder="no" framespacing="0" allowfullscreen="true" style="width: 100%; height: 100%;"></iframe>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>